export default __webpack_public_path__ + "static/media/all_work.a3998d2f.svg";